module.exports = __webpack_public_path__ + "img/Marca4.9eb5f5f2.jpg";